import React from 'react';
import Code from '../../Code/Code';
import EmbedCodeCopyButton from '../../EmbedCodeCopyButton/EmbedCodeCopyButton';
import { UnControlled as ReactCodeMirror } from 'react-codemirror2';
import getHostUrlForIntegrations from '../../../../../services/mini/getHostUrlForIntegrations';

const htmlCodeMirrorOptions = {
    lineNumbers: false,
    readOnly: true,
    mode: {
        name: 'javascript',
    },
    scrollbarStyle: null,
    cursorScrollMargin: -1000,
};
const googleFontCode = '<link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">';

const alanElectronInstallCode = 'npm install @alan-ai/alan-sdk-web --save';

const alanElectronImportCode = '<script src="node_modules/@alan-ai/alan-sdk-web/dist/alan_lib.js"></script>';

function alanElectronComponentCode(alanKey) {
    return `<script>
  alanBtn({ 
    key: '${alanKey}',
    host: '${getHostUrlForIntegrations()}',
    onCommand: (commandData) => {
      if (commandData.command === 'go:back') {
        //call client code that will react to the received command
      }
    },
  });
</script>`;
}

export function ElectronTab({ alanKey }) {
    return <div className="embed-code-tab">
        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc5">
                Install the Alan SDK Web package
            </div>
            <div className="embed-code-tab_dash embed-code-desc5">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_highlighted-code">
                    <Code highlighted={true} category="bash" type="code">
                        {alanElectronInstallCode}
                    </Code>
                    <div className="embed-code-tab_copy">
                        <EmbedCodeCopyButton code={alanElectronInstallCode} />
                    </div>
                </div>
            </div>
        </div>
        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc5">
                Include the script tag to index.html
            </div>
            <div className="embed-code-tab_dash embed-code-desc5">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_highlighted-code">
                    <Code highlighted={true} category="bash" type="code">
                        {alanElectronImportCode}
                    </Code>
                    <div className="embed-code-tab_copy">
                        <EmbedCodeCopyButton code={alanElectronImportCode} />
                    </div>
                </div>
            </div>
        </div>
        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc5">
                Add the Alan button to your component. Handle commands from the Alan AI Studio
            </div>
            <div className="embed-code-tab_dash embed-code-desc5">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_highlighted-code">
                    <ReactCodeMirror
                        value={alanElectronComponentCode(alanKey)}
                        options={htmlCodeMirrorOptions} />
                    <div className="embed-code-tab_copy">
                        <EmbedCodeCopyButton code={alanElectronComponentCode(alanKey)} />
                    </div>
                </div>
            </div>
        </div>
        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc2">
                Add a link to the font
            </div>
            <div className="embed-code-tab_dash embed-code-desc2">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_highlighted-code">
                    <Code highlighted={true} category="web" type="tag">
                        {googleFontCode}
                    </Code>
                    <div className="embed-code-tab_copy">
                        <EmbedCodeCopyButton code={googleFontCode} />
                    </div>
                </div>
            </div>
        </div>
    </div>;
}
